/* eslint-disable react-hooks/exhaustive-deps */
import { createStyles, FormControl, FormControlLabel, IconButton, makeStyles, Radio, RadioGroup, Theme } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { ChartCommonProps, IconButtonWrapper } from '../Common';
import { ChartFilter } from '../ChartComponents';
// import { SearchCriteria } from '../SearchCriteria';
import CloseIcon from '@material-ui/icons/Close';
import { convertStringNumberToNumber, formatNumber, GetArrow, getLabels, getMaxTickLimit, getSuggestedMaxTick } from '../../helpers/ChartHelper';
import { DrillDownType } from '../DrillDownType';
import { SelectedItemProps } from '../MattersByStatusChart';
import gql from 'graphql-tag';
import { useQuery } from 'react-apollo';
import moment from 'moment';
import { SearchCriteria } from '../SearchCriteria';
import { Bar, getElementAtEvent } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, Scale, Tick, Chart, ChartEvent, ActiveElement } from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom';
import { ChartInfo } from '../../components/ChartInfo';
import MTooltip from '@material-ui/core/Tooltip';
import { AIIcon } from '../../components/icons/AIIcon';
import html2canvas from 'html2canvas';
import { AIChartDialog } from '../../components/Dialogs/AIChartDialog';

import { RV_CHART_CLASS, RV_CHART_COLORS, rvBarDatasetStyle, rvChartAnimation, rvValueAxisStyle, rvCategoryAxisStyle, rvTooltipStyle, isChartDataEmpty, rvLegendLabels } from '../chartTheme';
import { ChartHeading } from '../ChartHeading';
import { AnimatedNumber } from '../AnimatedNumber';
import { ChartSkeleton } from '../../components/loading/ChartSkeleton';
import { ChartEmptyState } from '../ChartEmptyState';
import TimelineOutlinedIcon from '@material-ui/icons/TimelineOutlined';
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, zoomPlugin);

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            position: 'relative',
            paddingBottom: '10px',
            flex: 1,
            display: 'flex',
            flexFlow: 'column',
            maxWidth: '100%',
            maxHeight: '100%',
            height: '100%',
            textAlign: 'center',
            '@media print': {
                display: 'flex',
                flexFlow: 'column',
                alignItems: 'center',
                boxShadow: 'none !important',
            },
        },
        popover: {},
        paper: {},
        radioGroup: {
            flexFlow: 'row wrap',
            justifyContent: 'center',
        },
        closeIcon: {
            color: 'rgb(0, 120, 212)',
        },
        titleContainer: {
            display: 'flex',
            flexFlow: 'column',
            padding: '20px 15px 0px 15px',
        },
        barContainer: {
            padding: '5px 15px 15px 15px',
            minHeight: '300px',
            flex: 1,
            display: 'flex',
            flexFlow: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            maxHeight: '350px',
            maxWidth: 'auto',
            position: 'relative',
            '@media (max-width: 533px)': {
                maxWidth: '350px',
                margin: '0 auto',
            },
            '& .titleWrapper': {
                textAlign: 'center',
                display: 'inline-block',
                width: '100%',
                padding: '15px',
                '& .title': {
                    fontSize: '18px',
                    fontWeight: 600,
                    display: 'block',
                    marginBottom: '15px',
                },
                '& .value': {
                    fontSize: '24px',
                    fontWeight: 600,
                    display: 'block',
                    marginBottom: '15px',
                },
                '& .secondary-title': {
                    fontSize: '16px',
                    fontWeight: 400,
                    display: 'block',
                    marginBottom: '15px',
                },
            },
        },
        loadingWrapper: {
            padding: '20px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
        },
        title: {
            fontSize: 16,
            fontWeight: 600,
            fontFamily: 'inherit',
            marginBottom: 0,
        },
        totalDiv: {
            cursor: 'pointer',
            paddingRight: 5,
        },
        total: {
            fontSize: '2.5rem',
            padding: '10px 0',
            fontWeight: 600,
            cursor: 'pointer',
        },
        subTotal: {
            fontSize: '18px',
            padding: '10px 0',
            fontWeight: 600,
            cursor: 'pointer',
        },
        span: {
            fontSize: '1rem',
        },
        helpIcon: {
            position: 'absolute',
            left: '5px',
            top: '5px',
            '@media print': {
                display: 'none !important',
            },
        },
        formControl: {
            display: 'flex',
            flexFlow: 'row wrap',
            alignItems: 'center',
            justifyContent: 'center',
        },
        formLabel: {
            marginRight: '10px',
        },
    }),
);

export enum BillingByGroupOptionEnum {
    FEES_BILLED = 0,
    FEES_RECORDED,
    FEES_COLLECTED
}

interface BudgetYearForecastChartProps extends SelectedItemProps, ChartCommonProps {
    chartFilter?: ChartFilter;
    // groupBy: 'PersonActing' | 'PersonAssisting' | 'PersonResponsible';
}

interface ChartState {
    options: BillingByGroupOptionEnum;
    totalValueAmount: number;
    groupings: Date[];
    formats: string[];
    valueAmounts: number[];
    staffBudgets: StaffBudget[];
    actualsAmount: number[];
    symbol: string;
    fyTotal: number;
}

export const BudgetYearForecastChart: React.FC<BudgetYearForecastChartProps> = (props) => {
    const classes = useStyles();

    const entireChartRef = React.useRef<any>();

    // tslint:disable-next-line:no-any
    const chartRef = React.useRef<any>();

    const [state, setState] = useState<ChartState>({
        options: BillingByGroupOptionEnum.FEES_BILLED,
        groupings: [],
        formats: [],
        valueAmounts: [],
        staffBudgets: [],
        actualsAmount: [],
        totalValueAmount: 0,
        symbol: '$',
        fyTotal: 0,
    });

    const [base64Data, setBase64Data] = useState<string | ArrayBuffer | null>(null);
    
    const [isAIDialogOpen, setIsAIDialogOpen] = useState<boolean>(false);

    const [isBlobGenerating, setIsBlobGenerating] = useState<boolean>(false);

    // tslint:disable-next-line:no-any
    const budgetYearQuery = useQuery<BudgetYearData>(BUDGET_YEAR_CHART, {
        variables: {
            // groupBy: props.groupBy,
            entityType: props.chartFilter?.entityType,
            entityGuid: props.chartFilter?.entityGuid,
            responsibility: props.chartFilter?.responsibility,
        },
        fetchPolicy: 'cache-and-network',
    });

    const currencySymbolQuery = useQuery<CurrencySymbolData>(CURRENCY_SYMBOL_QUERY);

    useEffect(() => {
        if (currencySymbolQuery.data && currencySymbolQuery.data.options && !currencySymbolQuery.loading && !currencySymbolQuery.error) {
            setState((prevState) => {
                return {
                    ...prevState,
                    symbol: currencySymbolQuery.data!.options.currencySymbol.symbol,
                };
            });
        }

        // tslint:disable-next-line: align
    }, [currencySymbolQuery.loading, currencySymbolQuery.error, currencySymbolQuery.data]);

    useEffect(() => {
        setState((prevState) => {
            let groupings: Date[] = [];
            let formats: string[] = [];
            let valueAmounts: number[] = [];
            let totalValueAmount: number = 0;
            let _staffBudgets: StaffBudget[] = [];
            let actualsAmount: number[] = [];
            let fyTotal: number = 0;

            if (budgetYearQuery.data && budgetYearQuery.data.statistics && budgetYearQuery.data.statistics.fees && budgetYearQuery.data.statistics.fees.yearBudgetsForecast) {
                // tslint:disable-next-line: max-line-length
                const { summaries, staffBudgets, lastThreeMonthsActuals } = budgetYearQuery.data.statistics.fees.yearBudgetsForecast;

                _staffBudgets = staffBudgets;
                groupings = staffBudgets.map((staffBudget: StaffBudget) => staffBudget.grouping);
                formats = staffBudgets.map((staffBudget: StaffBudget) => staffBudget.format);
                if (state.options === BillingByGroupOptionEnum.FEES_BILLED) {
                    totalValueAmount = summaries.totalFeesBilled;
                    valueAmounts = staffBudgets.map((staffBudget: StaffBudget) => staffBudget.feesBilled);
                    actualsAmount = lastThreeMonthsActuals.map((lastThreeMonthsActuals: StaffBudget) => lastThreeMonthsActuals.feesBilled);
                    fyTotal = summaries.fYTotalFeesBilledBudget;
                } else if (state.options === BillingByGroupOptionEnum.FEES_COLLECTED) {
                    totalValueAmount = summaries.totalFeesCollected;
                    valueAmounts = staffBudgets.map((staffBudget: StaffBudget) => staffBudget.feesCollected);
                    actualsAmount = lastThreeMonthsActuals.map((lastThreeMonthsActuals: StaffBudget) => lastThreeMonthsActuals.feesCollected);
                    fyTotal = summaries.fYTotalFeesCollectedBudget;
                } else if (state.options === BillingByGroupOptionEnum.FEES_RECORDED) {
                    totalValueAmount = summaries.totalFeesRecorded;
                    valueAmounts = staffBudgets.map((staffBudget: StaffBudget) => staffBudget.feesRecorded);
                    actualsAmount = lastThreeMonthsActuals.map((lastThreeMonthsActuals: StaffBudget) => lastThreeMonthsActuals.feesRecorded);
                    fyTotal = summaries.fYTotalFeesRecordedBudget;
                } 
            }

            return {
                ...prevState,
                groupings,
                formats,
                valueAmounts,
                totalValueAmount,
                staffBudgets: _staffBudgets,
                actualsAmount,
                fyTotal,
            };
        });
        // tslint:disable-next-line: align
    }, [budgetYearQuery.data, budgetYearQuery.loading, budgetYearQuery.error, state.options]);

    const onCloseChart = () => {
        if (props.onCloseChart) {
            props.onCloseChart(`isFinancialYearBudgetForecastChart`);
        }
    };

    const handleTotalClick = () => {
        if (props.getSelectedItem) {
            const searchCriterias = new Array<SearchCriteria>();
            searchCriterias.push({ property: 'FullFinancialYear', operator: '', comparison: '' });

            props.getSelectedItem(searchCriterias, true, `Drilldown from ${getBudgetYear(state.groupings)} Budget Forecast`, DrillDownType.staffBillingSummary, 'Budget Forecast');
        }
    };

    const handleFullYearTotalClick = () => {
        if (props.getSelectedItem) {
            const searchCriterias = new Array<SearchCriteria>();
            searchCriterias.push({ property: 'FullFinancialYear', operator: '', comparison: '' });

            props.getSelectedItem(searchCriterias, true, `${getBudgetYear(state.groupings)} Budget`, DrillDownType.staffBillingSummary, 'Yearly Budgets');
        }
    };

    const onChangeRadio = (event: React.ChangeEvent<HTMLInputElement>) => {
        const fieldName = event.target.name;
        setState((prevState) => {
            return {
                ...prevState,
                // tslint:disable-next-line: radix
                [fieldName]: parseInt((event.target as HTMLInputElement).value),
            };
        });
    };

    const getGroupByTitle = (option: BillingByGroupOptionEnum) => {
        if (option === BillingByGroupOptionEnum.FEES_BILLED) {
            return 'Fees Billed';
        } else if (option === BillingByGroupOptionEnum.FEES_RECORDED) {
            return 'Fees Recorded';
        } else if (option === BillingByGroupOptionEnum.FEES_COLLECTED) {
            return 'Fees Collected';
        } else {
            return 'Non-Billable Hours';
        }
    };

    

    const getTotal = (total: number) => {
        return `${state.symbol}${formatNumber(total)}`;
    };

    const onPan = (context: { chart: Chart }) => {
        chartRef.current.options.scales.y.min = 0;
        chartRef.current.update();
    };

    const onHover = (event: ChartEvent, elements: ActiveElement[], chart: Chart) => {
        (event?.native?.target as HTMLElement).style.cursor = elements.length > 0 ? 'pointer' : 'auto';
    };

    const getBudgetYear = (groupings: Date[]) => {
        
        const startYear = moment(groupings[0]);
        const endYear = moment(groupings[groupings.length - 1]);

        if (startYear.isValid() && endYear.isValid()) {
            return `${startYear.format('YYYY')}/${endYear.format('YY')}`;
        }

        return startYear.isValid() ? startYear.format('YYYY') : endYear.isValid() ? endYear.format('YY') : '';
                
    };

    const chartName = getBudgetYear(state.groupings) + ' Budget Forecast';


    const onAIGeneratedSuggestion = async (event: any) => {

        setIsBlobGenerating(true);

        event.preventDefault();
        event.stopPropagation();
       
        if (entireChartRef && entireChartRef.current) {
            const canvas = await html2canvas(entireChartRef.current);
            canvas.toBlob((blob) => {
                if (blob) {
                    const reader = new FileReader();
                    reader.readAsDataURL(blob);
                    reader.onloadend = async () => {
                        const tempBase64data = reader.result;
                        // console.log(tempBase64data); // This is your image blob string
                        setBase64Data(tempBase64data);
                        setIsAIDialogOpen(true);
                    };
                }
            });
        }

        setIsBlobGenerating(false);
    };
    
    if (budgetYearQuery.loading) {
        return (
            <ChartSkeleton variant="columns" />
        );
    }

    return (
        <>
            {isAIDialogOpen && (
                <AIChartDialog 
                    fullWidth={true}
                    maxWidth="md"
                    open={isAIDialogOpen}
                    onClose={() => setIsAIDialogOpen(false)}
                    data={base64Data}
                    query={props.aiPrompt || 'Give me recommendations on this and highlight any exceptions or concerns'}
                    accessSubType={chartName}
                    layoutId={props.layoutId}
                />
            )}
            <div className={`${classes.root} ${RV_CHART_CLASS}${isChartDataEmpty(state.actualsAmount, state.valueAmounts) ? ' rv-chart--empty' : ''}`} ref={entireChartRef}>
<IconButtonWrapper aria-label="close">
                    <ChartInfo 
                        description={props.description}
                        fontSize={props.showAllRecords ? 'large' : 'medium'}
                        className={`${classes.helpIcon} rv-chart-help`}
                    />
                    {props.isAIFeatureEnabled && (
                        <MTooltip title="AI Assistant">
                            <IconButton 
                                disabled={isBlobGenerating}
                                size={props.showAllRecords ? 'medium' : 'small'}
                                onClick={onAIGeneratedSuggestion}
                            >
                                <AIIcon 
                                    color="primary"
                                    fontSize={props.showAllRecords ? 'large' : 'medium'}
                                />
                            </IconButton>
                        </MTooltip>
                    )}
                    <IconButton aria-label="close" onClick={onCloseChart} size="small">
                        <CloseIcon className={classes.closeIcon} />
                    </IconButton>
                </IconButtonWrapper>
                <div className={classes.titleContainer}>
                    <ChartHeading icon={<TimelineOutlinedIcon />} title={chartName} />
                    <div className={`${classes.total} h2`} onClick={handleTotalClick}>
                        <AnimatedNumber value={state.totalValueAmount} format={getTotal} />
                        {GetArrow(state.totalValueAmount, state.fyTotal)}
                    </div>
                    <div 
                        className={classes.subTotal}
                        onClick={handleFullYearTotalClick}
                    >
                        {`Full Year Budget ${state.symbol}${formatNumber(state.fyTotal)}`}
                    </div>
                    <div className={classes.title}>Actuals to Previous Month + Budget to End of Year</div>
                    <div className={classes.title}>{getGroupByTitle(state.options)}</div>
                </div>
                <div className={classes.barContainer}>
                    <Bar
                        ref={chartRef}
                        // tslint:disable-next-line: no-any
                        onClick={(event: React.MouseEvent<any>) => {
                            const _data = getElementAtEvent(chartRef.current, event);
                            if (_data.length > 0 && props.getSelectedItem) {
                                // const _index = getElementAtEvent(chartRef.current, event)[0].index;

                                // const item = state.formats[_index];

                                // const searchCriterias = new Array<SearchCriteria>();
                                // if (state.options === BillingByGroupOptionEnum.FEES_BILLED) {
                                //     searchCriterias.push({ property: 'FullFinancialYear', operator: 'eq', comparison: 'FullearFeesBilled' });
                                // } else if (state.options === BillingByGroupOptionEnum.FEES_COLLECTED) {
                                //     searchCriterias.push({ property: 'FullFinancialYear', operator: 'eq', comparison: 'FullYearFeesCollected' });
                                // } else if (state.options === BillingByGroupOptionEnum.FEES_RECORDED) {
                                //     searchCriterias.push({ property: 'FullFinancialYear', operator: 'eq', comparison: 'FullYearFeesRecorded' });
                                // } else if (state.options === BillingByGroupOptionEnum.BILLABLE_HOURS) {
                                //     searchCriterias.push({ property: 'FullFinancialYear', operator: 'eq', comparison: 'FullYearBillableHrs' });
                                // } else {
                                //     searchCriterias.push({ property: 'FullFinancialYear', operator: 'eq', comparison: 'FullYearNon-BillableHrs' });
                                // }
                                // props.getSelectedItem(
                                //     searchCriterias,
                                //     true,
                                //     `Full Financial Year`,
                                //     DrillDownType.matterSummaryDrilldown,
                                //     'Next Next Full Financial Year'
                                // );
                            }
                        }}
                        data={{
                            labels: getLabels(state.formats),
                            datasets: [
                                {
                                    label: 'Actual',
                                    ...rvBarDatasetStyle(RV_CHART_COLORS.primary),
                                    data: state.actualsAmount,
                                },
                                {
                                    label: 'Forecast',
                                    ...rvBarDatasetStyle(RV_CHART_COLORS.primarySoft),
                                    data: state.valueAmounts,
                                }
                            ],
                        }}
                        options={{
                            onHover: onHover,
                            indexAxis: 'x' as const,
                            animation: rvChartAnimation(),
                        elements: { bar: { borderWidth: 0 } },
                            responsive: true,
                            maintainAspectRatio: false,
                            scales: {
                                y: {
                                    grid: rvValueAxisStyle.grid,
                                    // beginAtZero: true,
                                    suggestedMax: getSuggestedMaxTick(state.valueAmounts),
                                    beginAtZero: true,
                                    ticks: {
                                        ...rvValueAxisStyle.ticks,
                                        maxTicksLimit: getMaxTickLimit(state.valueAmounts),
                                        autoSkip: false,
                                        callback: function (this: Scale, tickValue: number, index: number, ticks: Tick[]) {
                                            // tslint:disable-next-line: max-line-leng
                                            return `${state.symbol} ${formatNumber(tickValue)}`;
                                        },
                                    },
                                },
                                x: {
                                    grid: rvCategoryAxisStyle.grid,
                                    // min: 0,
                                    // max: 9 // minimum display
                                    ticks: {
                                        ...rvCategoryAxisStyle.ticks,
                                        autoSkip: false,
                                    }
                                }
                            },
                            plugins: {
                                legend: {
                                    position: 'bottom' as const,
                                    display: true,
                                    labels: rvLegendLabels,
                                },
                                title: {
                                    display: false,
                                    text: ``,
                                },
                                zoom: {
                                    pan: {
                                        enabled: false,
                                        onPan: onPan,
                                    },
                                    zoom: {
                                        wheel: {
                                            enabled: false,
                                        },
                                    },
                                    // limits: {
                                    //   y: { min: 0, max: 9 },
                                    // },
                                },
                                tooltip: {
                                    ...rvTooltipStyle,
                                    callbacks: {
                                        // tslint:disable-next-line: no-any
                                        label: function (context: any) {
                                            const {
                                                //   dataIndex,
                                                //   label,
                                                formattedValue,
                                                // dataset,
                                            } = context;

                                            var currentValue = convertStringNumberToNumber(formattedValue);

                                            let label = 'Fees Billed';
                                            let value = `${state.symbol}${formatNumber(currentValue)}`;
                                            if (state.options === BillingByGroupOptionEnum.FEES_BILLED) {
                                                label = 'Fees Billed';
                                            } else if (state.options === BillingByGroupOptionEnum.FEES_COLLECTED) {
                                                label = 'Fees Collected';
                                            } else if (state.options === BillingByGroupOptionEnum.FEES_RECORDED) {
                                                label = 'Fees Recorded';
                                            }

                                            return [`${label}: ${value}`];

                                        },
                                        // tslint:disable-next-line: no-any no-shadowed-variable
                                        afterLabel: function (context: any) {

                                            const { dataIndex } = context;
                                            const { feesRecorded, feesCollected, feesBilled } = state.staffBudgets[dataIndex];

                                            if (state.options === BillingByGroupOptionEnum.FEES_BILLED) {
                                                return [
                                                    `Fees Recorded: ${state.symbol}${formatNumber(feesRecorded)}`,
                                                    `Fees Collected: ${state.symbol}${formatNumber(feesCollected)}`
                                                ];
                                            } else if (state.options === BillingByGroupOptionEnum.FEES_COLLECTED) {
                                                return [
                                                    `Fees Recorded: ${state.symbol}${formatNumber(feesRecorded)}`,
                                                    `Fees Billed: ${state.symbol}${formatNumber(feesBilled)}`
                                                ];
                                            } else if (state.options === BillingByGroupOptionEnum.FEES_RECORDED) {
                                                return [
                                                    `Fees Billed: ${state.symbol}${formatNumber(feesBilled)}`,
                                                    `Fees Collected: ${state.symbol}${formatNumber(feesCollected)}`
                                                ];
                                            } else {
                                                return [
                                                    `Fees Recorded: ${state.symbol}${formatNumber(feesRecorded)}`,
                                                    `Fees Billed: ${state.symbol}${formatNumber(feesBilled)}`,
                                                    `Fees Collected: ${state.symbol}${formatNumber(feesCollected)}`
                                                ];
                                            }
                                        },
                                    },
                                },
                            },
                        }}
                    />
                    {isChartDataEmpty(state.actualsAmount, state.valueAmounts) && (
                        <ChartEmptyState title="No budget data" hint={"There is no actual or forecast data yet."} />
                    )}
                </div>
                <FormControl component="div" className={classes.formControl}>
                    <RadioGroup name="options" value={state.options} onChange={onChangeRadio} className={classes.radioGroup}>
                        <FormControlLabel value={BillingByGroupOptionEnum.FEES_BILLED} control={<Radio color="primary" />} label="Fees Billed" />
                        <FormControlLabel value={BillingByGroupOptionEnum.FEES_RECORDED} control={<Radio color="primary" />} label="Fees Recorded" />
                        <FormControlLabel value={BillingByGroupOptionEnum.FEES_COLLECTED} control={<Radio color="primary" />} label="Fees Collected" />
                    </RadioGroup>
                </FormControl>
                {/* {state.matterBillingByGroup.length >= 10 && <span className={classes.span}>The top 10 are shown</span>} */}
            </div>
        </>
    );
};

export interface CurrencySymbolData {
    options: Options;
}

export interface Options {
    currencySymbol: CurrencySymbol;
}

export interface CurrencySymbol {
    symbol: string;
}

export const CURRENCY_SYMBOL_QUERY = gql`
    query CurrencySymbol {
        options {
            currencySymbol {
                symbol
            }
        }
    }
`;
export interface BudgetYearData {
    statistics: Statistics;
}

export interface Statistics {
    fees: Fees;
}

export interface Fees {
  yearBudgetsForecast: YearBudgetsForecast;
}

export interface YearBudgetsForecast {
    staffBudgets: StaffBudget[];
    summaries: Summaries;
    lastThreeMonthsActuals: StaffBudget[];
}

export interface StaffBudget {
    feesRecorded: number;
    feesCollected: number;
    feesBilled: number;
    grouping: Date;
    format: string;
}

export interface Summaries {
    totalFeesRecorded: number;
    totalFeesCollected: number;
    totalFeesBilled: number;
    fYTotalFeesBilledBudget: number;
    fYTotalFeesCollectedBudget: number;
    fYTotalFeesRecordedBudget: number;
}


const BUDGET_YEAR_CHART = gql`
query YearBudgetsForecastData($entityType: Int, $entityGuid: String, $responsibility: Int) {
  statistics {
    fees {
      yearBudgetsForecast(entityType: $entityType, entityGuid: $entityGuid, responsibility: $responsibility) {
        lastThreeMonthsActuals{
          feesRecorded
          feesCollected
          feesBilled
          grouping
          format
        }
        staffBudgets {
          feesRecorded
          feesCollected
          feesBilled
          grouping
          format
          __typename
        }
        summaries {
          totalFeesRecorded
          totalFeesCollected
          totalFeesBilled
          fYTotalFeesBilledBudget
          fYTotalFeesCollectedBudget
          fYTotalFeesRecordedBudget
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }
}
`;
